import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { LocationListScreen } from 'screens/location';

export default withPermissions(LocationListScreen, [
  GroupSecurity.LocationRead,
]);
